module.exports = __webpack_public_path__ + "static/media/leaders-hoh.325851ec.jpg";